import { Config } from './Config';

export const ABUtils = {
    getABs: () => Config.get('ab'),

    isHsaDesktopActive({ isPrime } = {}) {
        const { isHSAHotelFunnel, isHSAPrimeLogged } = this.getABs();

        const isHsaAbActive = isHSAHotelFunnel && !isHSAPrimeLogged;
        const isHsaOnlyPrimeAbActive = Boolean(isPrime) && isHSAHotelFunnel && isHSAPrimeLogged;

        return isHsaAbActive || isHsaOnlyPrimeAbActive;
    },

    isHsaMobileActive({ isPrime } = {}) {
        const { isHSAHotelFunnelMobile, isHSAHotelFunnelNative, isHSAPrimeLoggedMobile } =
            this.getABs();

        const isMobileHsaAbActive =
            (isHSAHotelFunnelMobile || isHSAHotelFunnelNative) && !isHSAPrimeLoggedMobile;
        const isMobileHsaOnlyPrimeAbActive =
            Boolean(isPrime) &&
            (isHSAHotelFunnelMobile || isHSAHotelFunnelNative) &&
            isHSAPrimeLoggedMobile;

        return isMobileHsaAbActive || isMobileHsaOnlyPrimeAbActive;
    },
};
